import { useSearchParams } from 'react-router-dom';
import { X } from 'lucide-react';

/**
 * The `?q=` a search result opened this list with - an expense or a bank line
 * has no page of its own, so the result opens the list narrowed to it.
 */
export function useSearchTerm(): { q: string; clear: () => void } {
  const [params, setParams] = useSearchParams();
  const q = params.get('q')?.trim() ?? '';
  const clear = () => {
    const next = new URLSearchParams(params);
    next.delete('q');
    setParams(next, { replace: true });
  };
  return { q, clear };
}

/** Says the list is narrowed, and takes the narrowing off. Nothing when it is not. */
export function SearchChip({ q, onClear }: { q: string; onClear: () => void }) {
  if (!q) return null;
  return (
    <div className="flex items-center gap-2 text-sm" data-testid="search-chip">
      <span className="text-muted-foreground">Showing matches for</span>
      <span className="inline-flex max-w-full items-center gap-1 rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary">
        <span className="truncate">“{q}”</span>
        <button type="button" onClick={onClear} aria-label="Clear the search" className="rounded-full hover:bg-primary/20">
          <X className="size-3" aria-hidden />
        </button>
      </span>
    </div>
  );
}
